// extracted by mini-css-extract-plugin
export default {"container":"es-z","brandName":"fs-z","productName":"gs-z","productNamePdpEnhancements":"hs-z","breakLongProductName":"is-z"};